import React, { useEffect, useState } from 'react'
import { toast } from 'react-toastify'
import ChatBox from './Chatbox'
import FollowerList from './FollowerList'
import FollowingList from './FollowingList'
import BlockedList from './BlockedList'
import RequestList from './RequestList'
import '../../assets/css/FollowersList.css'
import { useDispatch, useSelector } from 'react-redux'
import { followerList } from '../../redux/slice/FollowersList'
import { useLocation, useNavigate } from 'react-router-dom'
import { followUser } from '../../redux/slice/FollowUser'
import Loader from '../../components/loader/Loader'
import debounce from "lodash/debounce"
import { chatNotification } from '../../redux/slice/ChatNotification'
import { userFilter } from '../../redux/slice/UserFilter'
import { Clock12, Link, QrCode, UserPlus } from 'lucide-react'
import { FaBan, FaCheck, FaComments, FaIdCard, FaTimes, FaUserMinus } from 'react-icons/fa'
import { Badge, Button } from 'react-bootstrap'
import BiolinkQRCode from '../biolink-page/BiolinkQRCode'

export default function FollowersList() {
    const [activeTab, setActiveTab] = useState('followers')
    const [spinner, setspinner] = useState(false)
    const [bool, setBool] = useState(false)
    const [showChat, setShowChat] = useState(false)
    const [selectedFollower, setSelectedFollower] = useState(null)
    const [loading, setLoading] = useState(false)
    const [loading2, setLoading2] = useState(false)
    const navigate = useNavigate()
    const dispatch = useDispatch()
    const followerData = useSelector(state => state?.followerList?.data?.[0])
    const chatNotificationData = useSelector(state => state?.chatNotification?.data)
    // const filterUser = useSelector(state => state?.userFilter?.data)
    const { state } = useLocation()
    const followers = followerData?.followerData
    const following = followerData?.followingData
    const blocked = followerData?.blockFollowerData
    const incomingRequests = followerData?.pendingFollowerData || []
    const outgoingRequests = followerData?.pendingFollowingData || []

    // Handler functions

    const handleFollow = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?._id,
            status: 'follow',
        })).then((res) => follow_res(res.payload))
    }

    const handleBlock = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user ? user?.user?._id : user?._id,
            status: 'blocked',
        })).then((res) => follow_res(res.payload))
    }

    const handleFollowingBlock = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user ? user?.user?._id : user?._id,
            status: 'block',
        })).then((res) => follow_res(res.payload))
    }


    const handleUnfollow = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user ? user?.user?._id : user?._id,
            status: 'unfollow',
        })).then((res) => follow_res(res.payload))
    }

    const handleFollowingRemove = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: user?.user ? user?.user?._id : user?._id,
            following_id: localStorage.getItem('id'),
            status: 'unfollow',
        })).then((res) => follow_res(res.payload))
    }

    const handleUnblock = (user) => {
        setspinner(true)

        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user_status === 'block' ? user?.following_id : user?.follower_id,
            status: 'unblocked',
        })).then((res) => follow_res(res.payload))
    }

    const handleAccept = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: user?.user ? user?.user?._id : user?._id,
            following_id: localStorage.getItem('id'),
            status: 'accepted',
        })).then((res) => follow_res(res.payload))
    }

    const handleReject = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user ? user?.user?._id : user?._id,
            status: 'rejected',
        })).then((res) => follow_res(res.payload))
    }

    const handleWithdraw = (user) => {
        setspinner(true)
        dispatch(followUser({
            follower_id: localStorage.getItem('id'),
            following_id: user?.user ? user?.user?._id : user?._id,
            status: 'withdraw',
        })).then((res) => follow_res(res.payload))
    }

    const follow_res = (res) => {
        if (res.status == 200 || res.status == 201) {
            toast.success(res?.data?.message, { position: "bottom-right" });
            setBool(!bool)
            setFilterUserData([])
            setspinner(false)

        } else {
            toast.error(res?.data?.message, { position: "bottom-right" });
            setspinner(false)
            setFilterUserData([])
            setBool(!bool)
        }
    }

    const handleChat = (user) => {
        console.log("user", user)
        setSelectedFollower(user)
        setShowChat(true)
    }

    const handleCloseChat = () => {
        setShowChat(false)
        setSelectedFollower(null)
    }


    const getInitials = (name) => {
        if (!name || name === 'undefined' || name === 'null') return 'U'
        // Trim and filter empty strings to handle trailing or double spaces
        const names = name.trim().split(' ').filter(n => n.length > 0)
        if (names.length >= 2) {
            return (names[0][0] + names[names.length - 1][0]).toUpperCase()
        }
        return name.trim().substring(0, 2).toUpperCase()
    }

    useEffect(() => {
        setLoading(true)
        setActiveTab(state?.activeKey || 'followers')
        dispatch(followerList({ navigate })).then((res) => list_res(res.payload))
    }, [bool])

    useEffect(() => {
        const interval = setInterval(() => {
            const token = localStorage.getItem('token');
            if (token) {
                dispatch(chatNotification({ navigate }))
            }
        }, 5000);
        return () => clearInterval(interval);
    }, [])

    const list_res = (res) => {
        console.log(res)
        if (res?.status == 200) {
            setLoading(false)
        } else {
            setLoading(false)
        }
    }


    const [search, setSearch] = useState('')
    const [pageSize, setPageSize] = useState(1)
    const [totalCount, setTotalCount] = useState('')
    const [filterUserData, setFilterUserData] = useState([])
    const PAGE_LIMIT = 10
    const apiTotal = Number(totalCount) || 0
    const rangeStart = filterUserData.length ? ((pageSize - 1) * PAGE_LIMIT) + 1 : 0
    const rangeEnd = filterUserData.length ? Math.min(rangeStart + filterUserData.length - 1, apiTotal) : 0
    const isLastPage = !apiTotal || rangeEnd >= apiTotal || pageSize >= Math.ceil(apiTotal / PAGE_LIMIT)

    const paginationNextFun = () => {
        if (search.trim().length < 5 || isLastPage) return
        const nextPage = pageSize + 1
        setPageSize(nextPage)
        setLoading2(true)
        dispatch(userFilter({ search: search, page: nextPage, limit: PAGE_LIMIT, navigate }))
            .then((res) => filter_res(res?.payload));
    }

    const paginationPrevFun = () => {
        if (search.trim().length < 5) return
        if (pageSize > 1) {
            const prevPage = pageSize - 1
            setPageSize(prevPage)
            setLoading2(true)
            dispatch(userFilter({ search: search, page: prevPage, limit: PAGE_LIMIT, navigate }))
                .then((res) => filter_res(res?.payload));
        }
    }

    const handleSearch = debounce((e) => {
        const query = e.trim();
        setPageSize(1); // Reset page index for new search
        setSearch(query);
        if (query.length >= 5) {
            setLoading2(true);
            dispatch(userFilter({ search: query, page: 1, limit: PAGE_LIMIT, navigate }))
                .then((res) => filter_res(res?.payload));
        } else {
            setLoading2(false);
            setFilterUserData([]);
            setTotalCount(0);
        }
    }, 500);

    const filter_res = (res) => {
        if (res?.status === 200) {
            setLoading2(false);
            const list = res?.data?.data || []
            setFilterUserData(list.slice(0, PAGE_LIMIT));
            setTotalCount(res?.data?.totalCount);
        } else {
            setLoading2(false);
            setFilterUserData([])
        }
    }

    const [qrShow, setQRShow] = useState(false)
    const [qrCode, setQrCode] = useState(false)

    const handleQR = (data) => {
        setQrCode(data)
        setQRShow(true)
    }


    return (
        <>
            <div className="container-fluid">
                <div className="row">
                    <div className="col-md-12">
                        <div className='layout'>
                            <h5 className='mb-0'>Connection Management</h5>

                        </div>
                    </div>
                </div>

                <div className="row mt-3">
                    <div className="col-md-12">
                        {/* Tab Navigation */}
                        <div className="followers-tab-navigation d-flex gap-2 mb-3">

                            <button
                                className={`followers-tab-button ${activeTab === 'followers' ? 'active' : ''}`}
                                onClick={() => setActiveTab('followers')}
                            >
                                Followers List
                            </button>
                            <button
                                className={`followers-tab-button ${activeTab === 'following' ? 'active' : ''}`}
                                onClick={() => setActiveTab('following')}
                            >
                                Following List
                            </button>
                            <button
                                className={`followers-tab-button ${activeTab === 'requests' ? 'active' : ''}`}
                                onClick={() => setActiveTab('requests')}
                            >
                                Request List
                            </button>
                            <button
                                className={`followers-tab-button ${activeTab === 'blocked' ? 'active' : ''}`}
                                onClick={() => setActiveTab('blocked')}
                            >
                                Blocked List
                            </button>
                            <button
                                className={`followers-tab-button ${activeTab === 'search' ? 'active' : ''}`}
                                onClick={() => setActiveTab('search')}
                            >
                                Search Users
                            </button>

                        </div>

                        {/* Tab Content */}
                        {loading ? (
                            <div className="col-md-12 layout text-center">
                                <Loader />
                            </div>
                        ) :
                            <div className="followers-tab-content">
                                {activeTab === 'followers' && (
                                    <FollowerList
                                        followers={followers}
                                        onBlock={handleBlock}
                                        onChat={handleChat}
                                        chatNotificationData={chatNotificationData}
                                        onUnfollow={handleFollowingRemove}
                                        // getProfileImage={getProfileImage}
                                        getInitials={getInitials}
                                    />
                                )}
                                {activeTab === 'following' && (
                                    <FollowingList
                                        following={following}
                                        chatNotificationData={chatNotificationData}
                                        onUnfollow={handleUnfollow}
                                        onChat={handleChat}
                                        // getProfileImage={getProfileImage}
                                        handleFollowingBlock={handleFollowingBlock}
                                        getInitials={getInitials}
                                    />
                                )}
                                {activeTab === 'blocked' && (
                                    <BlockedList
                                        blocked={blocked}
                                        onUnblock={handleUnblock}
                                        // getProfileImage={getProfileImage}
                                        getInitials={getInitials}
                                    />
                                )}
                                {activeTab === 'requests' && (
                                    <RequestList
                                        incomingRequests={incomingRequests}
                                        outgoingRequests={outgoingRequests}
                                        onAccept={handleAccept}
                                        onReject={handleReject}
                                        onWithdraw={handleWithdraw}
                                        getInitials={getInitials}
                                    />
                                )}
                                {activeTab === 'search' && (
                                    <div className="row">
                                        <div className="col-md-12 mt-2">
                                            <div className='layout d-flex flex-column flex-md-row align-items-start align-items-md-center justify-content-between gap-3'>
                                                <div className="search-box" style={{ maxWidth: '300px', width: '100%' }}>
                                                    <input
                                                        type="text"
                                                        className="form-control form_input"
                                                        placeholder="Search Users"
                                                        onChange={(e) => handleSearch(e.target.value)}
                                                        style={{
                                                            borderRadius: '8px',
                                                            padding: '8px 16px',
                                                            border: '1px solid #e2e8f0'
                                                        }}
                                                    />
                                                </div>
                                                <div className='mb-1'>
                                                    <div className='d-flex'>
                                                        <Button
                                                            variant="light"
                                                            size="md"
                                                            className="btn"
                                                            disabled={pageSize <= 1 || !apiTotal}
                                                            onClick={() => paginationPrevFun()}
                                                            style={{
                                                                border: "1px solid #dee2e6",
                                                                borderTopRightRadius: 0,
                                                                borderBottomRightRadius: 0,
                                                            }}
                                                        >
                                                            Prev
                                                        </Button>
                                                        <Button
                                                            variant="light"
                                                            size="md"
                                                            className="btn"
                                                            // disabled={right_disabled}

                                                            style={{
                                                                border: "1px solid #dee2e6",
                                                                borderTopLeftRadius: 0,
                                                                borderBottomLeftRadius: 0,
                                                            }}
                                                        >
                                                            {rangeStart} - {rangeEnd} of {apiTotal}
                                                        </Button>
                                                        <Button
                                                            variant="light"
                                                            size="md"
                                                            className="btn"
                                                            disabled={isLastPage}
                                                            onClick={() => paginationNextFun()}
                                                            style={{
                                                                border: "1px solid #dee2e6",
                                                                borderTopLeftRadius: 0,
                                                                borderBottomLeftRadius: 0,
                                                            }}
                                                        >
                                                            Next
                                                        </Button>

                                                    </div>
                                                </div>
                                            </div>
                                        </div>
                                        {loading2 ?
                                            <div className="row">
                                                <div className="col-md-12  mt-2 layout text-center">
                                                    <Loader />
                                                </div>
                                            </div> :
                                            filterUserData.length ?
                                                <div className="w-100">
                                                    <div className="followers-grid">
                                                        {filterUserData.map((follower, index) => {
                                                            const bioLinkdata = follower?.profile?.[0]
                                                            const profileImage = bioLinkdata?.profile_photo

                                                            // Handle potential 'undefined' strings from API and trailing spaces
                                                            const rawTitle = bioLinkdata?.title
                                                            const rawName = follower?.name
                                                            const validTitle = (rawTitle && rawTitle !== 'undefined' && rawTitle !== 'null') ? rawTitle : null
                                                            const validName = (rawName && rawName !== 'undefined' && rawName !== 'null') ? rawName : null

                                                            const userName = (validTitle || validName || 'User').trim()
                                                            const initials = getInitials(userName)
                                                            const userId = follower?.user_name
                                                            const unreadMsg = chatNotificationData?.find((item) => item?.sender_id === follower?._id)
                                                            const isBlocked =
                                                                (
                                                                    follower?.blockFollowingData?.[0]?.user_status === 'block' &&
                                                                    follower?.blockFollowingData?.[0]?.follower_id === localStorage.getItem('id')
                                                                ) ||
                                                                (
                                                                    follower?.blockFollowerData?.[0]?.user_status === 'blocked' &&
                                                                    follower?.blockFollowerData?.[0]?.following_id === localStorage.getItem('id')
                                                                );

                                                            const hasBlockData =
                                                                follower?.blockFollowerData?.length > 0 ||
                                                                follower?.blockFollowingData?.length > 0;
                                                            return (
                                                                <div key={index} className="follower-card">
                                                                    <div className="follower-card-header">
                                                                        <div className="follower-profile-section">
                                                                            {profileImage ? (
                                                                                <img
                                                                                    src={process.env.REACT_APP_BASE_URL + profileImage}
                                                                                    alt={userName}
                                                                                    className="follower-profile-image"
                                                                                    onError={(e) => {
                                                                                        e.target.style.display = 'none'
                                                                                        e.target.nextSibling.style.display = 'flex'
                                                                                    }}
                                                                                />
                                                                            ) : null}
                                                                            <div
                                                                                className="follower-profile-avatar"
                                                                                style={{ display: profileImage ? 'none' : 'flex' }}
                                                                            >
                                                                                {initials}
                                                                            </div>
                                                                            <div className="follower-profile-info">
                                                                                <h6 className="follower-name">{userName}</h6>

                                                                                <div className='d-flex align-items-center'>
                                                                                    <a
                                                                                        className="btn btn_qr_code"
                                                                                        href={process.env.REACT_APP_BASE_URL + `x/${follower?.user_name}`}
                                                                                        title="Copy URL"
                                                                                        target="_blank"
                                                                                    >
                                                                                        <Link size={15} className='mb-1' />
                                                                                    </a>
                                                                                    <button
                                                                                        className='ms-2 btn btn_qr_code'
                                                                                        onClick={() => handleQR(follower)}
                                                                                        title="QR Code"
                                                                                    >
                                                                                        <QrCode size={15} className='mb-1' />
                                                                                    </button>
                                                                                </div>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div className="follower-card-body">
                                                                        <div className="follower-info-item">
                                                                            <FaIdCard className="follower-info-icon" />
                                                                            <div className="follower-info-content">
                                                                                <span className="follower-info-label">Username</span>
                                                                                <span className="follower-info-value">{userId || 'N/A'}</span>
                                                                            </div>
                                                                        </div>
                                                                    </div>

                                                                    <div
                                                                        className="follower-card-footer"
                                                                        style={{ display: 'flex', flexWrap: 'nowrap', width: '100%', gap: '6px', overflow: 'hidden', padding: '10px' }}
                                                                    >
                                                                        {
                                                                            follower?.followerData?.length ?
                                                                                <>
                                                                                    <Button variant="warning" className="follower-action-btn"
                                                                                        style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                        onClick={() => handleFollowingRemove(follower)}
                                                                                    >  <FaUserMinus className="me-1" />  Remove  </Button>
                                                                                    <Button
                                                                                        variant="danger"
                                                                                        className="follower-action-btn"
                                                                                        style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                        onClick={() => handleBlock(follower)}
                                                                                    >
                                                                                        <FaBan className="me-1" />
                                                                                        Block
                                                                                    </Button>
                                                                                </>
                                                                                :
                                                                                follower?.followingData?.length ?
                                                                                    <>
                                                                                        <Button variant="warning" className="follower-action-btn"
                                                                                            style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                            onClick={() => handleUnfollow(follower)}
                                                                                        >  <FaUserMinus className="me-1" />  Remove  </Button>
                                                                                        <Button
                                                                                            variant="danger"
                                                                                            className="follower-action-btn"
                                                                                            style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                            onClick={() => handleFollowingBlock(follower)}
                                                                                        >
                                                                                            <FaBan className="me-1" />
                                                                                            Block
                                                                                        </Button>
                                                                                    </> :

                                                                                    hasBlockData && isBlocked ?
                                                                                        <Button
                                                                                            variant="secondary"
                                                                                            className="follower-action-btn"
                                                                                            style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                            onClick={() => handleUnblock(follower)}
                                                                                        >
                                                                                            <FaBan className="me-2" />
                                                                                            Unblock
                                                                                        </Button>
                                                                                        :
                                                                                        follower?.pendingFollowerData?.length ?
                                                                                            <Button
                                                                                                variant="danger"
                                                                                                className="follower-action-btn"
                                                                                                style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                                onClick={() => handleReject(follower)}
                                                                                            >
                                                                                                <FaTimes className="me-2" />
                                                                                                Reject
                                                                                            </Button>
                                                                                            :
                                                                                            follower?.pendingFollowingData?.length ?
                                                                                                <>
                                                                                                    <div
                                                                                                        className="follower-action-btn text-warning"
                                                                                                        style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis', background: 'transparent', border: 'none', cursor: 'default', pointerEvents: 'none' }}
                                                                                                    >
                                                                                                        <Clock12 size={16} className="me-1" />
                                                                                                        Pending
                                                                                                    </div>
                                                                                                    <Button
                                                                                                        variant="danger"
                                                                                                        className="follower-action-btn"
                                                                                                        style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                                        onClick={() => handleWithdraw(follower)}
                                                                                                    >
                                                                                                        <FaTimes className="me-2" />
                                                                                                        Withdraw
                                                                                                    </Button>
                                                                                                </> :
                                                                                                (
                                                                                                    follower?.blockFollowingData?.some(
                                                                                                        item =>
                                                                                                            item.user_status === 'blocked' &&
                                                                                                            item.follower_id === localStorage.getItem('id')
                                                                                                    ) ||
                                                                                                    follower?.blockFollowerData?.some(
                                                                                                        item =>
                                                                                                            item.user_status === 'block' &&
                                                                                                            item.following_id === localStorage.getItem('id')
                                                                                                    )
                                                                                                )
                                                                                                    ? '' :
                                                                                                    localStorage.getItem('id') != follower?._id &&
                                                                                                    <Button
                                                                                                        variant="success"
                                                                                                        className="follower-action-btn"
                                                                                                        style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                                        onClick={() => handleFollow(follower)}
                                                                                                    >
                                                                                                        <UserPlus className="me-2" />
                                                                                                        Follow
                                                                                                    </Button>

                                                                        }
                                                                        {follower?.pendingFollowerData?.length ?
                                                                            <Button
                                                                                variant="success"
                                                                                className="follower-action-btn"
                                                                                style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                onClick={() => handleAccept(follower)}
                                                                            >
                                                                                <FaCheck className="me-2" />
                                                                                Accept
                                                                            </Button> :
                                                                            follower?.followerData?.length || follower?.followingData?.length ?
                                                                                <Button
                                                                                    variant="primary"
                                                                                    className="follower-action-btn"
                                                                                    style={{ flex: '1 1 0%', minWidth: 0, margin: 0, padding: '8px 4px', fontSize: '12px', whiteSpace: 'nowrap', overflow: 'hidden', textOverflow: 'ellipsis' }}
                                                                                    onClick={() => handleChat(follower)}
                                                                                >
                                                                                    <FaComments className="me-2" />
                                                                                    Chat
                                                                                    {unreadMsg?.unreadCount > 0 && (
                                                                                        <Badge bg="warning" text='dark' className='ms-1'>{unreadMsg?.unreadCount}</Badge>
                                                                                    )}
                                                                                    <span className="visually-hidden">unread messages</span>
                                                                                </Button> : ''}
                                                                    </div>
                                                                </div>
                                                            )
                                                        })}
                                                    </div>
                                                </div> :
                                                <div>
                                                    <div className='layout text-center mt-1 p-5'>
                                                        <h6 className='mb-0'>No Users Found</h6>
                                                    </div>
                                                </div>
                                        }
                                    </div>
                                )}
                            </div>}
                    </div>
                </div>
            </div >

            {/* Chat OffCanvas - Now integrated in ChatBox component */}
            < ChatBox
                show={showChat}
                onHide={handleCloseChat}
                follower={selectedFollower}
            // fetchMessages={fetchMessages}
            // sendMessage={sendMessage}
            />
            <BiolinkQRCode qrShow={qrShow} setQRShow={setQRShow} qrCode={qrCode} />
        </>
    )
}
